import localAxios from '../../localAxios';
import { workspaceQuizURL } from '../workspacesURLs';

export interface SetWorkspaceQuizSharingParams {
  workspaceId: string;
  workspaceQuizId: string;
  sharable: boolean;
}

/**
 * Success → `{ sharable, socNumber }`. When the library's `allow_soc_code` is
 * off and enabling was attempted, the backend responds 200 with a locked
 * sentinel instead of changing anything.
 */
export type SetWorkspaceQuizSharingResponse =
  | { sharable: boolean; socNumber: string }
  | { locked: true; reason: 'library_setting' };

export async function setWorkspaceQuizSharing({
  workspaceId,
  workspaceQuizId,
  sharable,
}: SetWorkspaceQuizSharingParams): Promise<SetWorkspaceQuizSharingResponse> {
  const url = workspaceQuizURL({ workspaceQuizId, workspaceId });
  const response = await localAxios.put<SetWorkspaceQuizSharingResponse>(
    url.href,
    { sharable }
  );
  return response.data;
}
